const wrappers = document.querySelectorAll<HTMLElement>('.gform_wrapper')

/*
function getLabel(input: HTMLElement) {
  const parent = input.parentElement
  const label = parent?.querySelector('.gform-field-label')
  if (!label) {
    if (parent) {
      return getLabel(parent)
    }
    return null
  }
  return label
}
*/

function onKeyDown(evt: KeyboardEvent) {
  if (evt.key === 'Enter') {
    evt.preventDefault()
  }
}

function updateClass(input: HTMLInputElement | HTMLSelectElement) {
  let hasContent = true
  if (input instanceof HTMLSelectElement) {
    hasContent =
      !!input.value ||
      (!input.value && !!input.querySelector('option')?.textContent?.trim())
  } else {
    hasContent = input.value !== ''
  }
  input.classList.toggle('has-content', hasContent)
}

function onFocusOut(evt: Event) {
  updateClass(evt.target as HTMLInputElement)
}

const TEXT_INPUT_SELECTOR = `
input:is([type="text"], [type="email"], [type="tel"], [type="url"]), [type="number"]:not([placeholder]:not([placeholder=""]))
`

function attachInputs(wrapper: HTMLElement) {
  const inputs = wrapper.querySelectorAll<HTMLInputElement>('input')
  // const textareas = wrapper.querySelectorAll<HTMLTextAreaElement>('textarea')
  // const selects = wrapper.querySelectorAll<HTMLSelectElement>('select')
  const allInputs = [...inputs /*, ...textareas*/]
  for (const input of allInputs) {
    input.addEventListener('focusout', onFocusOut)
    updateClass(input as HTMLInputElement)
  }
  for (const input of inputs) {
    input.removeEventListener('keydown', onKeyDown as EventListener)
    input.addEventListener('keydown', onKeyDown as EventListener)
  }
  /*
  for (const select of selects) {
    select.removeEventListener('change', onFocusOut as EventListener)
    select.addEventListener('change', onFocusOut as EventListener)
    updateClass(select)
  }
  */

  const labels = wrapper.querySelectorAll<HTMLElement>('.gform-field-label')
  for (const label of labels) {
    const refId = label.getAttribute('for')
    if (refId) {
      const input = wrapper.querySelector<
        HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
      >(`#${refId}`)
      if (input?.matches(TEXT_INPUT_SELECTOR)) {
        input.parentElement?.classList.add('has-floating-label')
        input.parentElement?.insertBefore(label, input.nextElementSibling)
      }
    }
  }
}

for (const wrapper of wrappers) {
  attachInputs(wrapper)
}
